import { useEffect, useRef } from 'react';
import './StarField.css';

const STARS = [
  { x: 7,  y: 10, size: 28, color: '#F4A7C0', delay: 0 },
  { x: 89, y: 7,  size: 20, color: '#F5D97E', delay: 0.4 },
  { x: 76, y: 20, size: 16, color: '#7DCFCA', delay: 0.8 },
  { x: 17, y: 33, size: 14, color: '#B8A0D4', delay: 1.1 },
  { x: 93, y: 44, size: 24, color: '#F9B98A', delay: 0.2 },
  { x: 4,  y: 58, size: 14, color: '#7DCFCA', delay: 0.6 },
  { x: 54, y: 5,  size: 12, color: '#F4A7C0', delay: 1.3 },
  { x: 43, y: 17, size: 10, color: '#F5D97E', delay: 0.9 },
  { x: 83, y: 67, size: 18, color: '#B8A0D4', delay: 0.3 },
  { x: 11, y: 76, size: 12, color: '#F9B98A', delay: 1.5 },
];

const FADE_START_PX = 80;   // start fading after 80px scroll
const FADE_END_PX   = 500;  // fully gone at 500px scroll

export default function StarField() {
  const containerRef = useRef(null);
  const scrollRef    = useRef(0);
  const rafRef       = useRef(null);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    const onScroll = () => {
      scrollRef.current = window.scrollY;
      const s = scrollRef.current;
      const opacity =
        s < FADE_START_PX ? 1
        : s > FADE_END_PX  ? 0
        : 1 - (s - FADE_START_PX) / (FADE_END_PX - FADE_START_PX);

      container.style.opacity  = opacity;
      container.style.transform = `translateY(${s * 0.25}px)`;
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <div ref={containerRef} className="starfield-container">
      {STARS.map((star, i) => (
        <span
          key={i}
          className="star-icon"
          style={{
            left:      `${star.x}%`,
            top:       `${star.y}%`,
            fontSize:  `${star.size}px`,
            color:     star.color,
            animationDelay: `${star.delay}s`,
          }}
        >
          ★
        </span>
      ))}
    </div>
  );
}
